"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Details = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const Card_1 = require("./Card");
const Space_1 = require("./Space");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const layout_1 = require("../modules/layout");
class Details extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                title: {
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 22 : 18,
                    color: theme.textColor1
                },
                lineSection: {
                    paddingVertical: 10,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minHeight: 45
                },
                lineSectionCustomRender: {
                    padding: 0
                },
                lineText: {
                    fontFamily: theme.fontFamily2,
                    fontSize: (0, layout_1.isTablet)() ? 18 : 14,
                    color: theme.textColor1,
                    minWidth: 40
                },
                lineValue: {
                    textAlign: 'center'
                },
                lineTitle: {
                    textAlign: 'left',
                    flexShrink: 0
                },
                lineValueContainer: {
                    flexDirection: 'row',
                    flexGrow: 1,
                    flexShrink: 1,
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                },
                lineValueIcon: {
                    width: 25,
                    textAlign: 'center'
                }
            });
            return styles;
        };
        this.renderIcon = (icon, index) => {
            const styles = this.getStyles();
            const fa = (React.createElement(FontAwesome_1.default, { key: index, testID: (0, test_1.getTestID)(icon.name), name: icon.name, color: icon.color, size: icon.size, style: styles.lineValueIcon }));
            if (icon.onPress) {
                return (React.createElement(react_native_1.TouchableOpacity, { key: index, onPress: icon.onPress }, fa));
            }
            return fa;
        };
        this.renderLine = (line, index) => {
            const styles = this.getStyles();
            const { lineTitleStyle, lineValueStyle } = this.props;
            const { title, value, icons, render } = line;
            const sectionStyle = render
                ? styles.lineSectionCustomRender
                : styles.lineSection;
            const children = render ? (render()) : (React.createElement(React.Fragment, null,
                React.createElement(react_native_1.Text, { style: [styles.lineText, styles.lineTitle, lineTitleStyle] }, title),
                React.createElement(react_native_1.View, { style: styles.lineValueContainer },
                    icons && icons.map(this.renderIcon),
                    React.createElement(react_native_1.Text, { style: [styles.lineText, styles.lineValue, lineValueStyle] }, value))));
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(Space_1.Space, { height: 3 }),
                React.createElement(Card_1.Card, null,
                    React.createElement(Card_1.Card.Section, { style: sectionStyle }, children))));
        };
    }
    render() {
        const { title, lines } = this.props;
        const styles = this.getStyles();
        return (React.createElement(React.Fragment, null,
            React.createElement(Card_1.Card, null,
                React.createElement(Card_1.Card.Section, null,
                    React.createElement(react_native_1.Text, { style: styles.title }, title))),
            lines.map(this.renderLine)));
    }
}
exports.Details = Details;
